import jwtDecode from 'jwt-decode';
import Api from '../../app/services/api';

export const login = async (params) => {
  const { token } = await Api.post('/user/login', params);
  Api.setToken(token);
  window.sessionStorage.setItem('token', token);

  const decoded = jwtDecode(token);
  return decoded;
};

export const checkLoggedIn = () => {
  const token = window.sessionStorage.getItem('token');

  if (!token) {
    return {
      isAuth: false,
      user: undefined,
    };
  }

  const decoded = jwtDecode(token);

  if (Date.now() >= decoded.exp * 1000) {
    return {
      isAuth: false,
      user: undefined,
    };
  }

  Api.setToken(token);
  return {
    isAuth: true,
    user: decoded.user,
    company: decoded.company,
  };
};

export const logout = () => window.sessionStorage.removeItem('token');

export const forgotPassword = async (params) => Api.post('/user/forgot-password', params);

export const setPassword = async (params) => Api.post('/user/set-password', params);

export const checkActivationToken = async (params) => Api.post('/user/check-token', params);
